<template>
  <div :class="classes" v-bind="$attrs" v-on="$listeners">
    <div class="am-card-footer-title">
      <!-- @slot Left side content -->
      <slot />
    </div>
    <div class="am-card-footer-actions" v-if="$slots['actions']">
      <!-- @slot Right side content -->
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import { enumValidator } from "../enumValidator";

export default {
  inheritAttrs: false,
  props: {
    /**
     * Sets the footer horizontal align [left, center, right]
     */
    align: {
      type: String,
      validator: enumValidator(["left", "center", "right"]),
      default: "left"
    },
    /**
     * Sets divider on the top
     */
    divider: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        "am-card-footer",
        `am-card-footer--${this.align}`,
        {
          "am-card-footer--divider": this.divider
        }
      ];
    }
  }
};
</script>
